import isElementVisibleUtil from "./isElementVisible.util.js";
// wait for an element to appear in the DOM indefinitely
export const waitForElementUtil = ({ selector, checkVisibility = false, }) => new Promise((resolve) => {
    const interval = 100; // Polling interval
    const checkElement = () => {
        const element = document.querySelector(selector);
        if (element instanceof HTMLElement) {
            if (!checkVisibility || isElementVisibleUtil(element)) {
                resolve(element);
                return;
            }
        }
        setTimeout(checkElement, interval);
    };
    checkElement();
});
export default waitForElementUtil;
